import {CountryEnum, CountryType} from '@/enums/country.enum';
import { features } from './constants';

export interface stateAuthentication {
  email: string;
  isLogged: boolean;
  username: string;
  token: string;
  features: features[];
  loginWithError: boolean;
  makingLogin: boolean;
  idClient: number;
  clientName: string;
  userFullName: string;
  idVehicleType: number;
  country: CountryType;
}

export const defaultAuthenticationState: stateAuthentication = {
  username: '',
  email: '',
  token: '',
  isLogged: false,
  features: [],
  loginWithError: false,
  makingLogin: false,
  idClient: -1,
  clientName: '',
  userFullName: '',
  idVehicleType: -1,
  country: CountryEnum.Brasil
};

export const state = defaultAuthenticationState;
